import ProfileCard from "pages/Profile/ProfileCard";
import { Row } from "react-bootstrap";
import RecentActivityCard from "../Admin/RecentActivity";
import { useEffect, useState, useTransition } from "react";
import dashboard from "lib/deshboard-client";


function EditorDashboard() {
    const [masterData, setMasterData] = useState([]);
    const [modalList, setModalList] = useState([]);
    const [selectedModal, setSelectedModal] = useState(null);
    const [isPendingMaster, startTransition] = useTransition();

    const fetchModalList = async () => {
        const { updatedList, error } = await dashboard.fetchModalList()
        setModalList(updatedList);
        setSelectedModal(updatedList[0]);
    };
    const fetchReports = async (modalValue) => {
        const { data, error } = await dashboard.fetchReports(modalValue);
        startTransition(() => {
            setMasterData(data || {});
        });
    };
    useEffect(() => {
        fetchModalList();
    }, []);
    useEffect(() => {
        if (selectedModal) {
            fetchReports(selectedModal.value);
        }
    }, [selectedModal]);
    return (
        <>
            <Row className="mb-4 gx-3 gy-4 d-flex ">
                <ProfileCard />


                <RecentActivityCard
                    selectedModal={selectedModal}
                    modalList={modalList}
                    setSelectedModal={setSelectedModal}
                    masterData={masterData}
                />
            </Row>


        </>
    );
};


export default EditorDashboard;

